/* eslint-disable @typescript-eslint/no-explicit-any */
import { ColumnType, getStatusColor } from '@Common/Table';
import { PushHistory } from '@Models/types';
import { LinkObject, TestCases } from '@Models/types';

const parseDate = (timestamp: number) => {
  const date = new Date(timestamp);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  const formattedDate = `${month.toString().padStart(2, '0')}/${day
    .toString()
    .padStart(2, '0')}/${year}`;
  return formattedDate;
};

const parseTestCases = (tc: string) => {
  return JSON.parse(tc) as TestCases[];
};

const parseLinks = (links: string) => {
  return JSON.parse(links) as LinkObject[];
};

const PublishHistoryColumns: ColumnType<PushHistory>[] = [
  {
    header: 'Reference',
    accessor: 'test_cases',
    Cell: (value: any) => {
      const testcases = parseTestCases(value);

      return (
        <div>
          {testcases.map((testcase, index) => (
            <div key={index} className="py-1 text-xs">
              {testcase.reference_num ? (
                <label className="whitespace-nowrap font-bold tracking-tighter">
                  {testcase.reference_num}
                </label>
              ) : (
                <label className="italic tracking-tighter text-brandRed-500">
                  No Reference
                </label>
              )}
            </div>
          ))}
        </div>
      );
    },
  },
  {
    header: 'Test Cases',
    accessor: 'test_cases',
    Cell: (value: any) => {
      const testcases = parseTestCases(value);

      return (
        <div className="grid grid-cols-1 gap-1">
          {testcases.map((testcase, index) => (
            <div key={index} className="flex items-start">
              <span
                className="max-w-[500px] overflow-hidden text-ellipsis whitespace-nowrap pt-1 text-xs"
                title={testcase.name}
              >
                {testcase.name}
              </span>
            </div>
          ))}
        </div>
      );
    },
  },
  {
    header: 'Date',
    accessor: 'timestamp',
    Cell: (value: any) => <span className="text-xs">{parseDate(value)}</span>,
  },
  {
    header: 'Status',
    accessor: 'push_status',
    Cell: (value: any) => (
      <span className={`${getStatusColor(value)} text-xs font-bold uppercase`}>
        {value}
      </span>
    ),
  },
];

export { PublishHistoryColumns, parseDate, parseTestCases, parseLinks };
